import React, { useCallback, useContext } from 'react'
import { matchScheduleTypes, SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext'
import { SeasonMatchesContext } from '../cnr/contexts/SeasonMatchesContext'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { ParentContext } from 'global/cnr/contexts/ParentContext'


export const useSportMatch = ({
  matchAllows,
  forOverview = false,
}) => {

  const appUserAccess = useAppUserAccess()
  const { itemAccess } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { sportSettings } = aps_global ?? {}
  const { matchResultFullBackground } = sportSettings ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { _sportSeasonSettings, playoffDates } = sportsSeason_state ?? {}

  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state } = seasonMatchesContext ?? {}
  const { matchScheduleType, tournamentType } = seasonMatches_state ?? {}

  const getMatchCn = useCallback((match, teamKey, matchKey) => {

    const scheduleTypes = {
      match: matchKey ? true : false,
      team: teamKey ? true : false,
    }

    let _sportsMatch_cn = 'schedule-match'

    if (!match) { return _sportsMatch_cn }

    const {
      _resultsStatus,
      _results_matchDay,
      _results,
      _status,
      away,
      home,
      id,
      isPlayoff,
      key,
      location,
      pending,
    } = match ?? {}

    // NEW STUFF
    const { winner, scoreDisplays, complete, tied } = _results ?? {}

    const { edit: _allowEdit_match, scores: _allowEdit_scores, matchAccessLevel } = matchAllows ?? {}
    const { scoreType } = _resultsStatus ?? {}

    const { home: home_pending, away: away_pending } = pending ?? {}

    let loc = location ? location.name : null

    let _home = home
    let _away = away

    if (home_pending) { _home = home_pending }
    if (away_pending) { _away = away_pending }


    if (!_home && !_away) { return _sportsMatch_cn }

    const { isFuture, isMissing, isPast, isBye } = _status ?? {}
    const isPending = (!home || !away) ? true : false
    const teamIsHome = _home?.id === teamKey

    const _isPlayoff = false
    const keyy = key ? key : id

    if (matchScheduleType === matchScheduleTypes.latest) { _sportsMatch_cn += ' lmo' }
    if (_sportSeasonSettings && _sportSeasonSettings.useScoreBlock) { _sportsMatch_cn += ' blocked' }
    if (complete) { _sportsMatch_cn += ' complete' }

    if (tournamentType) {
      _sportsMatch_cn += ' pool'
    } else if (scheduleTypes.match) {
      _sportsMatch_cn += ' match'
    } else if (scheduleTypes.team && !_isPlayoff) {
      _sportsMatch_cn += ' teams'
    } else {
      _sportsMatch_cn += ' section'
    }

    if (matchResultFullBackground) { _sportsMatch_cn += ' fmrb' }

    if (playoffDates || isPlayoff) {
      _sportsMatch_cn += ' playoff'
    }

    const allowMatchEdits = { match: false, sport: false, any: false }

    allowMatchEdits.match = (itemAccess && ((_home && itemAccess.includes(_home?.id)) || (_away && itemAccess.includes(_away?.id)))) ? true : false
    allowMatchEdits.sport = (itemAccess && itemAccess.includes(sportsKey)) ? true : false

    const _scoreDisplays = scoreDisplays
    let { scores: scoreDisplay_scores } = _scoreDisplays ?? {}

    if (winner) {
      _sportsMatch_cn += winner.id === teamKey ? ' win' : ' loss'
      _sportsMatch_cn += winner.id === home.id ? ' wh' : ' wa'
    }

    if (tied && tied.length === 2) {
      _sportsMatch_cn += ' tie'
    }

    if (isFuture) { _sportsMatch_cn += ' future' }
    // if (complete) { _sportsMatch_cn += ' complete' }
    if (allowMatchEdits.any) { _sportsMatch_cn += ' ' + _cnEditTypes.allowMatchEdit } // ame
    if (allowMatchEdits.sport) { _sportsMatch_cn += ' ' + _cnEditTypes.allowScoreEdit } // ase
    if (_allowEdit_scores && !forOverview) { _sportsMatch_cn += ' ' + _cnEditTypes.allowAdminMatchEdit } // aame was ae
    if (matchAccessLevel) { _sportsMatch_cn += ' mal-' + matchAccessLevel }
    if (isBye) { _sportsMatch_cn += ' bye' }
    if (isPast && !winner && !_results_matchDay) { _sportsMatch_cn += ' no-res' }
    if (isPending) { _sportsMatch_cn += ' pending' }
    if (isMissing && !_results_matchDay) { _sportsMatch_cn += ' missing' }
    if (loc === _home.name) { _sportsMatch_cn += ' lch' }
    if (scoreType) { _sportsMatch_cn += ' ' + scoreType }

    if (teamIsHome) {
      _sportsMatch_cn += ' tih'
    } else {
      _sportsMatch_cn += ' tia'
    }

    if (scoreDisplay_scores && !forOverview) { _sportsMatch_cn += ' scrs' }

    return _sportsMatch_cn
  }, [])

  return { getMatchCn }

}
